module.exports = __webpack_public_path__ + "static/media/process.ae074a53.jpg";